import {
  FacebookLine,
  InstagramLine,
  LinkedinLine,
  TwitterLine,
  YoutubeLine,
} from "../components/customIcons";

const ICONS = [
  {
    id: 1,
    icon: FacebookLine,
    link: "https://www.facebook.com/profile.php?id=61550811991444",
    show: true,
  },
  {
    id: 2,
    icon: InstagramLine,
    link: "https://www.instagram.com/vellisfinancial/",
    show: false,
  },
  {
    id: 3,
    icon: TwitterLine,
    link: "https://twitter.com/Vellisfinancial",
    show: true,
  },
  {
    id: 4,
    icon: LinkedinLine,
    link: "https://www.linkedin.com/company/vellisfinancial",
    show: true,
  },
  {
    id: 5,
    icon: YoutubeLine,
    link: "https://www.youtube.com/@Vellis.financial",
    show: false,
  },
];

export default ICONS;
